import { render, staticRenderFns } from "./VideoParallax1.vue?vue&type=template&id=35afaf96&scoped=true"
import script from "./VideoParallax1.vue?vue&type=script&lang=js"
export * from "./VideoParallax1.vue?vue&type=script&lang=js"
import style0 from "./VideoParallax1.vue?vue&type=style&index=0&id=35afaf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afaf96",
  null
  
)

export default component.exports